/* /admin: the owner's page. Google sign-in (the app's stored session is shared, same origin), then
   is_admin() decides. Everything it does is enforced by RLS and security-definer functions in
   supabase/migrations/0005_waitlist.sql; this page only calls them. */
import { sessionClient, isMissing, isOffline } from "./supa.js";

var $ = function(id){ return document.getElementById(id); };
var PANELS = ["aLoading", "aSignIn", "aDenied", "aProblem", "aPanel"];
var KIND = {trades: "Trades", office: "Office / agency", shop: "Shop / hospitality", property: "Property / lettings", other: "Other"};
var STATUS = {waiting: "Waiting", invited: "Let in", declined: "Declined"};
var rows = [], client = null, armed = null, toastT = 0;

function esc(s){ return String(s == null ? "" : s).replace(/[&<>"']/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]; }); }
function show(id){ PANELS.forEach(function(p){ $(p).hidden = p !== id; }); }
function problem(title, text){ $("aProblemTitle").textContent = title; $("aProblemText").textContent = text; show("aProblem"); }
function toast(msg){
  var t = $("toast"); t.textContent = msg; t.hidden = false;
  clearTimeout(toastT); toastT = setTimeout(function(){ t.hidden = true; }, 4200);
}
function errText(err, status){
  if(isOffline(err, status)) return "Couldn't reach the server. Check your connection.";
  if(isMissing(err, status)) return "The database isn't set up for this yet: run supabase/migrations/0005_waitlist.sql in Supabase's SQL Editor.";
  return (err && err.message) || "Something went wrong.";
}
function fmtDate(s){
  var d = new Date(s); if(isNaN(d)) return "";
  return d.toLocaleDateString("en-GB", {day: "numeric", month: "short", year: "numeric"});
}

/* ---------- boot ---------- */
client = sessionClient();
if(!client){
  problem("Supabase isn't configured", "This build has no VITE_SUPABASE_URL / VITE_SUPABASE_PUBLISHABLE_KEY. Set them and rebuild.");
} else {
  $("aGoogle").addEventListener("click", function(){
    client.auth.signInWithOAuth({provider: "google", options: {redirectTo: location.origin + "/admin"}}).then(function(r){
      if(r.error) problem("Couldn't start sign-in", r.error.message);
    });
  });
  $("signOut").addEventListener("click", function(){
    client.auth.signOut().then(function(){ location.reload(); });
  });
  client.auth.getSession().then(function(res){
    var session = res.data && res.data.session;
    if(!session){ show("aSignIn"); return; }
    $("signOut").hidden = false;
    return client.rpc("is_admin").then(function(r){
      if(r.error){ problem("Couldn't check your account", errText(r.error, r.status)); return; }
      if(r.data !== true){
        $("aDeniedWho").textContent = "You're signed in as " + (session.user && session.user.email || "someone else") + ", which can't manage the waiting list.";
        show("aDenied"); return;
      }
      show("aPanel");
      loadAll();
    });
  }).catch(function(err){ problem("Couldn't check your account", errText(err, 0)); });
}

/* ---------- data ---------- */
function loadAll(){
  $("aRows").innerHTML = '<tr><td colspan="8" class="hint">Loading…</td></tr>';
  client.from("app_settings").select("signups_open").limit(1).maybeSingle().then(function(r){
    if(r.error){ toast(errText(r.error, r.status)); return; }
    setSignupsUI(!!(r.data && r.data.signups_open));
  });
  client.from("waitlist").select("id, created_at, name, email, business_kind, team_size, use_for, status, notes").order("created_at", {ascending: false}).then(function(r){
    if(r.error){ $("aRows").innerHTML = '<tr><td colspan="8">' + esc(errText(r.error, r.status)) + '</td></tr>'; return; }
    rows = r.data || [];
    render();
  });
}
function setSignupsUI(open){
  $("aSignups").checked = open;
  $("aSignupsLabel").textContent = open ? "Sign-ups open" : "Sign-ups closed";
  $("aSignupsHint").textContent = open
    ? "Anyone who signs in with Google gets a workspace."
    : "Only people you let in (and you) can create a workspace.";
}

function visible(){
  var f = $("aFilter").value, q = $("aSearch").value.trim().toLowerCase();
  return rows.filter(function(r){
    if(f !== "all" && r.status !== f) return false;
    if(!q) return true;
    return [r.name, r.email, r.use_for, r.notes, KIND[r.business_kind], r.team_size].join(" ").toLowerCase().indexOf(q) >= 0;
  });
}
function render(){
  var c = {all: rows.length, waiting: 0, invited: 0, declined: 0};
  rows.forEach(function(r){ if(c[r.status] != null) c[r.status]++; });
  $("aStats").innerHTML = [["all", "On the list"], ["waiting", "Waiting"], ["invited", "Let in"], ["declined", "Declined"]].map(function(s){
    return '<div class="stat"><b>' + c[s[0]] + '</b><span>' + s[1] + '</span></div>';
  }).join("");
  var list = visible();
  $("aRows").innerHTML = list.length ? list.map(function(r){
    var acts = (r.status !== "invited" ? '<button type="button" class="btn small primary" data-invite="' + esc(r.id) + '">Let in</button>' : "") +
      (r.status !== "declined" ? '<button type="button" class="btn small" data-decline="' + esc(r.id) + '">Decline</button>' : "");
    return '<tr>' +
      '<td data-l="Name"><b>' + esc(r.name) + '</b></td>' +
      '<td data-l="Email"><a href="mailto:' + esc(r.email) + '">' + esc(r.email) + '</a></td>' +
      '<td data-l="Business">' + esc(KIND[r.business_kind] || r.business_kind) + '</td>' +
      '<td data-l="Team">' + esc(r.team_size || "—") + '</td>' +
      '<td data-l="What for" class="use">' + esc(r.use_for || "—") + '</td>' +
      '<td data-l="Joined" class="date">' + esc(fmtDate(r.created_at)) + '</td>' +
      '<td data-l="Status"><span class="status ' + esc(r.status) + '">' + esc(STATUS[r.status] || r.status) + '</span></td>' +
      '<td class="acts">' + acts + '</td></tr>';
  }).join("") : '<tr><td colspan="8" class="hint">' + (rows.length ? "Nobody matches." : "Nobody on the waiting list yet.") + '</td></tr>';
}

/* ---------- actions ---------- */
$("aSearch").addEventListener("input", render);
$("aFilter").addEventListener("change", render);
$("aRefresh").addEventListener("click", loadAll);

$("aSignups").addEventListener("change", function(){
  var want = $("aSignups").checked;
  $("aSignups").disabled = true;
  client.rpc("admin_set_signups", {open: want}).then(function(r){
    $("aSignups").disabled = false;
    if(r.error){ setSignupsUI(!want); toast(errText(r.error, r.status)); return; }
    setSignupsUI(r.data === true);
    toast(r.data === true ? "Sign-ups are open to anyone with a Google account." : "Sign-ups are closed. Only people you let in can join.");
  });
});

$("aRows").addEventListener("click", function(e){
  var b = e.target.closest("button"); if(!b) return;
  if(b.dataset.invite){
    var id = b.dataset.invite;
    b.disabled = true;
    client.rpc("admin_invite", {waitlist_id: id}).then(function(r){
      b.disabled = false;
      if(r.error){ toast(errText(r.error, r.status)); return; }
      var row = rows.find(function(x){ return x.id === id; });
      if(row) row.status = "invited";
      render();
      toast("Let in " + (r.data || (row && row.email) || "") + ". Email them: they can sign in at " + location.origin + " now.");
    });
  } else if(b.dataset.decline){
    var did = b.dataset.decline;
    if(armed !== did){
      armed = did; b.textContent = "Sure?";
      setTimeout(function(){ if(armed === did){ armed = null; if(b.isConnected) b.textContent = "Decline"; } }, 3000);
      return;
    }
    armed = null; b.disabled = true;
    client.rpc("admin_decline", {waitlist_id: did}).then(function(r){
      b.disabled = false;
      if(r.error){ toast(errText(r.error, r.status)); return; }
      var row = rows.find(function(x){ return x.id === did; });
      if(row) row.status = "declined";
      render();
      toast("Declined " + (r.data || "") + ".");
    });
  }
});

function copy(text, what){
  var done = function(){ toast("Copied " + what + "."); };
  if(navigator.clipboard && navigator.clipboard.writeText){
    navigator.clipboard.writeText(text).then(done, function(){ fallback(); });
  } else fallback();
  function fallback(){
    var ta = document.createElement("textarea"); ta.value = text; ta.setAttribute("readonly", "");
    ta.style.position = "fixed"; ta.style.opacity = "0"; document.body.appendChild(ta); ta.select();
    try{ document.execCommand("copy"); done(); }catch(e){ toast("Couldn't copy."); }
    ta.remove();
  }
}
function copyStatus(st, label){
  var emails = rows.filter(function(r){ return r.status === st; }).map(function(r){ return r.email; });
  if(!emails.length){ toast("Nobody " + label + " yet."); return; }
  copy(emails.join(", "), emails.length + (emails.length === 1 ? " email" : " emails"));
}
$("aCopyWaiting").addEventListener("click", function(){ copyStatus("waiting", "waiting"); });
$("aCopyInvited").addEventListener("click", function(){ copyStatus("invited", "let in"); });

$("aDirect").addEventListener("submit", function(e){
  e.preventDefault();
  var el = $("aDirectEmail"), em = el.value.trim().toLowerCase();
  if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)){ el.setAttribute("aria-invalid", "true"); toast("That doesn't look like an email address."); el.focus(); return; }
  el.removeAttribute("aria-invalid");
  client.from("allowed_emails").insert({email: em}).then(function(r){
    if(r.error && r.error.code !== "23505" && r.status !== 409){ toast(errText(r.error, r.status)); return; }
    el.value = "";
    toast(r.error ? em + " was already let in." : "Let in " + em + ". They can sign in now.");
  });
});
